import { useAuth } from "@/auth.tsx";
import { canManageAgent } from "@/components/agents/agent-card.tsx";
import { useAgentPolicy } from "@/components/agents/use-agent-policy.ts";
import { AgentTriggerList } from "@/components/agents/schedule/agent-trigger-list.tsx";
import { m } from "@/paraglide/messages.js";
import { agentDefinitionQueryOptions } from "@/services/agent-definitions-service.ts";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { z } from "zod";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute(
	"/_authenticated/dashboard/agents/$agentId/triggers",
)({
	validateSearch: z.object({
		created: z.boolean().optional(),
		schedule: z.string().optional(),
	}),
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.agent_triggers_meta_title()) }],
	}),
});

function RouteComponent() {
	const { agentId } = Route.useParams();
	const { created, schedule } = Route.useSearch();
	const { user } = useAuth();
	const { data } = useSuspenseQuery(agentDefinitionQueryOptions(agentId));
	// Adding a trigger is editing the agent (ruling 6A), so bounce viewers who
	// cannot manage this agent — unlike the runs view, which a designated
	// approver who is not a manager must still reach.
	// The org policy can let a member manage their own shared agent.
	const policy = useAgentPolicy();
	if (!canManageAgent(data, user?.isAdmin ?? false, policy)) {
		return <Navigate to="/dashboard/agents" replace />;
	}
	return (
		<AgentTriggerList
			agentId={agentId}
			justCreated={created ?? false}
			suggestedSchedule={schedule}
		/>
	);
}
